import React from "react";
import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 40, className = "", once = true }) => (
    <motion.div
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once, margin: "-80px" }}
        transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
        className={className}
    >
        {children}
    </motion.div>
);

export const StaggerGroup = ({ children, className = "", delay = 0.1, stagger = 0.08 }) => (
    <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-80px" }}
        variants={{
            hidden: {},
            visible: { transition: { staggerChildren: stagger, delayChildren: delay } },
        }}
        className={className}
    >
        {children}
    </motion.div>
);

export const StaggerChild = ({ children, className = "", y = 30 }) => (
    <motion.div
        variants={{
            hidden: { opacity: 0, y },
            visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] } },
        }}
        className={className}
    >
        {children}
    </motion.div>
);

export default Reveal;
